import type { PolarYesNoUndefined } from "@stryker/core/types/section";
import PolarQuestion from "@/components/job/PolarQuestion";
import { Typography } from "@/components/ui/typography";

export type LeakingPolar = {
  component_leaking: PolarYesNoUndefined;
  is_pinhole_leak: PolarYesNoUndefined;
  component_patched_or_repaired: PolarYesNoUndefined;
};
type LeakingChecksProps = {
  onHandleYesNo: (payload: { value: PolarYesNoUndefined; key: keyof LeakingPolar }) => void;
  polarQuestions: LeakingPolar;
};
export function LeakingChecks({ onHandleYesNo, polarQuestions }: LeakingChecksProps) {
  return (
    <>
      <PolarQuestion
        shouldRender
        question="Is component leaking"
        onNoClick={() => onHandleYesNo({ value: "no", key: "component_leaking" })}
        onYesClick={() => onHandleYesNo({ value: "yes", key: "component_leaking" })}
        selection={polarQuestions.component_leaking}
      />
      <PolarQuestion
        shouldRender={polarQuestions.component_leaking === "yes"}
        question="Is the leak a pinhole?"
        onNoClick={() => {
          onHandleYesNo({ value: "no", key: "is_pinhole_leak" });
        }}
        onYesClick={() => {
          onHandleYesNo({ value: "yes", key: "is_pinhole_leak" });
        }}
        selection={polarQuestions.is_pinhole_leak}
      />
      <PolarQuestion
        shouldRender={polarQuestions.component_leaking === "no"}
        question="Has component been patched or repaired?"
        onNoClick={() => {
          onHandleYesNo({ value: "no", key: "component_patched_or_repaired" });
        }}
        onYesClick={() => {
          onHandleYesNo({ value: "yes", key: "component_patched_or_repaired" });
        }}
        selection={polarQuestions.component_patched_or_repaired}
      />
      {polarQuestions.component_patched_or_repaired === "yes" && (
        <Typography variant="text-md" weight="semibold" className="text-primary-500">
          Based on your inputs, the component is still considered leaking, please provide defect details underneath the
          patch or repair
        </Typography>
      )}
      <PolarQuestion
        shouldRender={polarQuestions.component_patched_or_repaired === "yes"}
        question="Is the leak a pinhole?"
        onNoClick={() => {
          onHandleYesNo({ value: "no", key: "is_pinhole_leak" });
        }}
        onYesClick={() => {
          onHandleYesNo({ value: "yes", key: "is_pinhole_leak" });
        }}
        selection={polarQuestions.is_pinhole_leak}
      />
    </>
  );
}
